import React, { useState } from "react";
import logoBanner from "../../assets/logo-banner.png";

const BrandLogo = ({ className = "" }) => {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <span className={`brand-logo-lockup ${className}`.trim()}>
      {!logoFailed && (
        <img
          src={logoBanner}
          alt="MyFarmingPal logo"
          className="brand-logo-mark"
          width="34"
          height="34"
          loading="eager"
          decoding="async"
          onError={() => setLogoFailed(true)}
        />
      )}
      <span className="brand-logo-text">MyFarmingPal</span>
    </span>
  );
};

export { logoBanner };
export default BrandLogo;
